import * as React from 'react';
import { DefaultButton, PrimaryButton, Icon } from 'office-ui-fabric-react';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import './NewOrderBasicDetails.scss';
import Header from '../../../common/Header';
import { INewOrderBasicDetailsProps, INewOrderBasicDetailsState, IOrderBasic, IFormValidation } from '../../../../interfaces/INewOrderBasicDetails';
import { _getInputService } from '../../../../services/event.service';
import { IEvent, IEventManager } from '../../../../interfaces/IEvent';
import { ProgressStatus } from '../../../../constants/GlobalConstants';
import history from '../../../../lib/history';
import Loader from '../../../common/loader/Loader';
import { ICancelOrder, IOrderDetails } from '../../../../interfaces/INewOrderAddItems';
import ConfimationBox from './ConfimationBox';
import { getStorage, setStorage, removeStorage } from '../../../../lib/LocalStorageService';

let eventOptions: IDropdownOption[] = [];
let eventManagerOptions: IDropdownOption[] = [];

export default class NewOrderBasicDetails extends React.Component<INewOrderBasicDetailsProps, INewOrderBasicDetailsState> {
  constructor(props: INewOrderBasicDetailsProps) {
    super(props);

    let _formValidation: IFormValidation = {
      ErrorOnEventName: '',
      ErrorOnLocation: '',
      ErrorOnParticipant: '',
      IsValidate: false
    };

    let _cancelOrder: ICancelOrder = {
      isConfirmed: false,
      hideDialog: true
    }

    this.state = {
      Events: [],
      ProgressStatus: ProgressStatus.Init,
      OrderBasic: this.initialOrderDetails(),
      FormValidation: _formValidation,
      CancelOrder: _cancelOrder
    }
  }

  componentDidMount() {
    this.getEvent();
  }

  private initialOrderDetails(): IOrderBasic {
    debugger;

    const _nextOrderBasicDetail: IOrderBasic = JSON.parse(getStorage("NextOrderBasicDetail"));
    const _orderbasic: IOrderBasic = {
      EventId: _nextOrderBasicDetail && _nextOrderBasicDetail.EventId ? _nextOrderBasicDetail.EventId : 0,
      EventName: _nextOrderBasicDetail && _nextOrderBasicDetail.EventName ? _nextOrderBasicDetail.EventName : '',
      EventManagerId: _nextOrderBasicDetail && _nextOrderBasicDetail.EventManagerId ? _nextOrderBasicDetail.EventManagerId : -1,
      EventManager: _nextOrderBasicDetail && _nextOrderBasicDetail.EventManager ? _nextOrderBasicDetail.EventManager : '',
      Email_EventManger: _nextOrderBasicDetail && _nextOrderBasicDetail.Email_EventManger ? _nextOrderBasicDetail.Email_EventManger : '',
      Location: _nextOrderBasicDetail && _nextOrderBasicDetail.Location ? _nextOrderBasicDetail.Location : '',
      Participant: _nextOrderBasicDetail && _nextOrderBasicDetail.Participant ? _nextOrderBasicDetail.Participant : ''
    };
    return _orderbasic;
  }
  private getEvent(): void {
    this.setState({ ProgressStatus: ProgressStatus.Loading });
    _getInputService().then(res => {
      // Events
      let filterEvents: IEvent[] = res.Events.map(
        (data: any) => {
          return {
            Id: data.ID,
            Title: `${data.Title}_${data.Eventnummer}_${data.Projectnummer}`,
          }
        });

      eventOptions = [];
      filterEvents.forEach(event => {
        eventOptions.push({
          key: event.Id,
          text: event.Title,
          data: {
            Id: event.Id,
            Title: event.Title
          }
        })
      });
      
      // Event managers
      let filterEventManagers: IEventManager[] = res.EventManagers.map(
        (data: any) => {
          return {
            Id: data.ID,
            Title: data.Title,
            Email: data.E_x002d_mail_x0020_eventmanager
          }
        });

      eventManagerOptions = [];
      filterEventManagers.forEach(eventManager => {
        eventManagerOptions.push({
          key: eventManager.Id,
          text: `${eventManager.Title} (${eventManager.Email})`,
          data: {
            Id: eventManager.Id,
            Title: eventManager.Title,
            Email: eventManager.Email
          }
        })
      });

      this.setState({
        ProgressStatus: ProgressStatus.Loaded,
        Events: filterEvents

      })
    });
  }

  private saveAndNext(): void {

    this.validateForm();
    setTimeout(() => {
      if (this.state.FormValidation.IsValidate) {
        const { OrderBasic } = this.state;
        debugger;


        let _orderDetailRecover = getStorage("OrderDetailRecover");
        let _orderDetailRecoverItem = [];
        if (_orderDetailRecover) {
          _orderDetailRecoverItem = JSON.parse(_orderDetailRecover).Items;
        }

        setStorage("OrderDetailRecover", JSON.stringify({
          OrderBasic: OrderBasic,
          Items: _orderDetailRecoverItem
        }));

        history.push({
          pathname: '/neworderadditems',
          state: { OrderBasic: OrderBasic }
        });
      }
    }, 100);
  }

  private cancelOrder(_isConfirm: boolean): void {
    const { CancelOrder } = this.state;
    if (CancelOrder.hideDialog == true) {
      this.setState({ CancelOrder: { hideDialog: false, isConfirmed: false } });
    } else {
      this.setState({ CancelOrder: { hideDialog: true, isConfirmed: false } });
      if (_isConfirm) {
        // clear order cache
        removeStorage("OrderDetailRecover");
        removeStorage("NextOrderBasicDetail");
        
        history.push("/dashboard");
      }
    }
  }

  private onTextChangeEvent = (name: string, value: string, data?: any) => {
    this.setState(prevState => ({
      OrderBasic: {
        EventName: name == "EventName" ? data.Title : prevState.OrderBasic.EventName,
        EventId: name == "EventName" ? data.Id : prevState.OrderBasic.EventId,
        EventManagerId: name == "EventManager" ? data.Id : prevState.OrderBasic.EventManagerId,
        EventManager: name == "EventManager" ? data.Title : prevState.OrderBasic.EventManager,
        Email_EventManger: name == "EventManager" ? data.Email : prevState.OrderBasic.Email_EventManger,
        Location: name == "Location" ? value : prevState.OrderBasic.Location,
        Participant: name == "Participant" ? value : prevState.OrderBasic.Participant,
      }
    }));
    setTimeout(() => {
      setStorage("NextOrderBasicDetail", JSON.stringify(this.state.OrderBasic));
    }, 500);
  }

  private validateForm = (): void => {
    const { FormValidation, OrderBasic } = this.state;
    let _errorOnEventName: string,
        _errorOnManager: string,
        _errorOnLocation: string,
        _errorOnParticipant: string,
        _isValidate: boolean;

    if (OrderBasic.EventName == "") {
      _errorOnEventName = "Event is verplicht";
    }
    if (OrderBasic.EventManager == "") {
      _errorOnManager = "Eventmanager is verplicht";
    }
    if (OrderBasic.Location == "") {
      _errorOnLocation = "Locatie is verplicht";
    }
    if (OrderBasic.Participant == "") {
      _errorOnParticipant = "Deelnemer is verplicht";
    }
    if (OrderBasic.EventName != "" && OrderBasic.Location != "" && OrderBasic.Participant != "") {
      _isValidate = true;
    }

    this.setState(prevState => ({
      FormValidation: {
        ErrorOnEventName: _errorOnEventName,
        ErrorOnManager: _errorOnManager,
        ErrorOnLocation: _errorOnLocation,
        ErrorOnParticipant: _errorOnParticipant,
        IsValidate: _isValidate
      }
    }));
  }


  public render() {
    const { OrderBasic, FormValidation, CancelOrder } = this.state;

    const sortedEventOptions = [...eventOptions];
    sortedEventOptions.sort((a, b) => a.text.localeCompare(b.text));
    const sortedEventManagerOptions = [...eventManagerOptions];
    sortedEventManagerOptions.sort((a, b) => a.text.localeCompare(b.text));

    return (
      this.state.ProgressStatus != ProgressStatus.Loaded ?
        <Loader PageTitle="<b>Nieuwe meerwerkbon</b> scherm wordt geladen" /> :
        <div className="page pb-5">
          <Header isBackVisible={false} />
          <div className="container mt-5">
            <div className="ms-Grid bottom-border-input">
              <div className="ms-Grid-row">
                <div className="ms-Grid-row form-group">
                  <Dropdown placeholder="Selecteer een event"
                    className="ms-Grid-col ms-sm11 ms-md11 ms-lg11"
                    label="Voor welk event is de meerwerkbon bedoeld?*" options={sortedEventOptions}
                    onChanged={(option: IDropdownOption, index?: number) => {
                      this.onTextChangeEvent("EventName", option.key.toString(), option.data)
                    }}
                    errorMessage={FormValidation.ErrorOnEventName}
                    selectedKey={this.state.OrderBasic.EventId}
                  />
                </div>
                <div className="ms-Grid-row form-group">
                  <Dropdown placeholder="Selecteer een eventmanager"
                    className="ms-Grid-col ms-sm11 ms-md11 ms-lg11"
                    label="Naar welke eventmanager moet de meerwerkbon worden verstuurd?*" options={sortedEventManagerOptions}
                    onChanged={(option: IDropdownOption, index?: number) => {
                      this.onTextChangeEvent("EventManager", option.key.toString(), option.data)
                    }}
                    errorMessage={FormValidation.ErrorOnEventName}
                    selectedKey={this.state.OrderBasic.EventManagerId}
                  />
                </div>
                <div className="ms-Grid-row form-group">
                  <TextField label="Locatie*" className="ms-Grid-col ms-sm11 ms-md11 ms-lg11"
                    placeholder="Vul de locatie in voor de meerwerkbon " value={OrderBasic.Location}
                    onChange={(e, value) => this.onTextChangeEvent("Location", value || '')}
                    errorMessage={FormValidation.ErrorOnLocation} />
                  {OrderBasic.Location && <Icon
                    iconName="Cancel" className=" ms-Grid-col ms-sm1 ms-md1 ms-lg1"
                    style={{ marginTop: 42, cursor: "pointer" }}
                    onClick={() => this.onTextChangeEvent("Location", "")}

                  />}
                </div>
                <div className="ms-Grid-row form-group">
                  <TextField label="Deelnemer*" className="ms-Grid-col ms-sm11 ms-md11 ms-lg11" name="Participant" placeholder="Vul de deelnemer in voor de meerwerkbon" value={OrderBasic.Participant}
                    onChange={(e, value) => this.onTextChangeEvent("Participant", value || '')}
                    errorMessage={FormValidation.ErrorOnParticipant} />
                  {OrderBasic.Participant && <Icon
                    iconName="Cancel" className=" ms-Grid-col ms-sm1 ms-md1 ms-lg1"
                    style={{ marginTop: 42, cursor: "pointer" }}
                    onClick={() => this.onTextChangeEvent("Participant", "")}
                  />}
                </div>
              </div>
            </div>
          </div>
          <div className="bottom-btns">
            <div className="container">
              <div className="row justify-content-between">
                <DefaultButton className="btn-outline-danger" text="Annuleer bon" onClick={() => this.cancelOrder(false)} allowDisabledFocus />
                <PrimaryButton text="Volgende" onClick={this.saveAndNext.bind(this)} allowDisabledFocus />
              </div>
            </div>
          </div>

          <ConfimationBox
            isConfirmed={CancelOrder.isConfirmed}
            title="Meerwerkbon annuleren?"
            subTitle="Alle gegevens zullen verloren gaan"
            noText="Nee"
            yesText="Ja"
            hideDialog={CancelOrder.hideDialog}
            _yes={() => this.cancelOrder(true)}
            _no={() => this.cancelOrder(false)}
          />
        </div>
    );
  }
}
